import React, { useEffect, useState } from "react";
import "./CollectionsView.css";
import LeftNavigationBar from "../LeftNavigationBar/LeftNavigationBar";
import CollectionCreator from "./CollectionCreator/CollectionCreator";
import CollectionSvg from '../../assets/images/svgs/Collection.svg?react';
import AddSvg from '../../assets/images/svgs/Add.svg?react';
import AssetIconSvg from '../../assets/images/svgs/AssetIcon.svg?react'
import { useDispatch, useSelector } from "react-redux";
import { getCollections } from "../../services/collections.service";
import { formatFullDate } from "../../common/utils/helperFunctions";
import { togglePopup } from "../../slices/collectionSlice";
import { getStacCollections } from "../../services/stac.service";
import { Loader } from "rsuite";

const CollectionsView = () => {
  const dispatch = useDispatch();
  const isCollectionPopupOpen = useSelector((state) => state.collectionDetails.isCollectionPopupOpen);
  const [updatedCollections, setUpdatedCollections] = useState([]);
  const [loadingCollections, setLoadingCollections] = useState(true);

  function mergeCollections(stacCollections, customCollections) {

    // Create a map for quick lookup of itemCount using stacCollections
    const stacData = stacCollections.reduce((map, collection) => {
      map[collection.id] = collection.itemCount;
      return map;
    }, {});

    // Map over customCollections and append the itemCount
    const updatedData = customCollections.map((collection) => {
      return {
        ...collection,
        itemCount: stacData[collection.collectionID] || 0
      };
    });

    setUpdatedCollections(updatedData);
    setLoadingCollections(false);
  };

  const getCollectionsSuccess = () => {
    dispatch(getStacCollections(mergeCollections));
  };

  useEffect(() => {
    dispatch(getCollections(getCollectionsSuccess));
  }, [dispatch]);

  const handleCollectionCreator = () => {
    dispatch(togglePopup());
  };

  return (
    <div className="collectionsView">
      <LeftNavigationBar />
      <div className="collections-section">
        <div className="collections-header bottomBorder">
          <div>
            <span className="collections-icon"> <CollectionSvg /> </span>
            <span className="collections-title">Collections</span>
          </div>
          <div>
            {!loadingCollections && <button className="collections-btn"
              onClick={handleCollectionCreator}
            ><AddSvg />Collection</button>}
          </div>
        </div>
        {isCollectionPopupOpen &&
          <CollectionCreator
            successCallback={getCollectionsSuccess}
            setLoadingCollections={setLoadingCollections} />}
            {loadingCollections ? <Loader inverse center content="Loading..."/> :
          <div className="collections-list-view">
            {updatedCollections.map((item) => (
              <div className="collections-list-item bottomBorder" key={item.collectionID}>
                <div className="collections-item-details">
                  <div className="collections-item-title">{item.displayName}</div>
                  <div className="collections-item-sub-title">{formatFullDate(item.createdAt)}</div>
                </div>
                <div className="collections-item-content">
                  <div className="collections-item-summary-icon"><AssetIconSvg /></div>
                  <div className="collections-item-summary-detail">{item.itemCount}</div>
                </div>
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  );
};

export default CollectionsView;
